module.exports = __webpack_public_path__ + "static/media/clock.f2c33028.png";